var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconOperations = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.063 5.658h-.47a.88.88 0 0 0-.937.809v.78a.79.79 0 0 1-.417.672l-.989.569.989.568a.79.79 0 0 1 .417.672v.78a.88.88 0 0 0 .938.808h.468m1.875-5.658h.47a.88.88 0 0 1 .937.809v.78a.79.79 0 0 0 .417.672l.989.569-.989.568a.79.79 0 0 0-.417.672v.78a.88.88 0 0 1-.938.808h-.469m5.626 2.78a.94.94 0 0 1-.938.937H2.375a.937.937 0 0 1-.937-.937V1.908a.94.94 0 0 1 .937-.937h9.403c.245 0 .48.095.655.267l1.847 1.8a.94.94 0 0 1 .283.672z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.063 5.658h-.47a.88.88 0 0 0-.937.809v.78a.79.79 0 0 1-.417.672l-.989.569.989.568a.79.79 0 0 1 .417.672v.78a.88.88 0 0 0 .938.808h.468m1.875-5.658h.47a.88.88 0 0 1 .937.809v.78a.79.79 0 0 0 .417.672l.989.569-.989.568a.79.79 0 0 0-.417.672v.78a.88.88 0 0 1-.938.808h-.469m5.626 2.78a.94.94 0 0 1-.938.937H2.375a.937.937 0 0 1-.937-.937V1.908a.94.94 0 0 1 .937-.937h9.403c.245 0 .48.095.655.267l1.847 1.8a.94.94 0 0 1 .283.672z"
  }));
});
export default SvgIconOperations;
export const raw = __webpack_public_path__ + "static/media/IconOperations.f0f352fcddcf12e022231b83ad2b4797.svg";